import { render, staticRenderFns } from "./Registeration2026.vue?vue&type=template&id=2b833070&scoped=true&"
import script from "./Registeration2026.vue?vue&type=script&lang=js&"
export * from "./Registeration2026.vue?vue&type=script&lang=js&"
import style0 from "./Registeration2026.vue?vue&type=style&index=0&id=2b833070&prod&scoped=true&lang=css&"
import style1 from "./Registeration2026.vue?vue&type=style&index=1&id=2b833070&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b833070",
  null
  
)

export default component.exports